export default __webpack_public_path__ + "static/FrontPageBannerMobile-0473184b08415419d36e6e420c142865.png";